import React, { useEffect, useState } from 'react';
import '../../../../../../App.css';
import { useNavigate } from 'react-router-dom';
import StampDuty from '../../../../../../core/assets/files/Paye.csv';
import { ErrorToast } from '../../../../../componets/toast';
import { Modal, Table } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  useCreateSinglePaymentRequest,
  useGetBatchId,
  useGetUserBankDetails,
} from '../../hooks/usePayment';
import { MetroSpinner } from 'react-spinners-kit';
import { formatMoneyLocal, isEmpty } from '../../../../../../core/helpers';
import { PaymentUploadSummary } from '../../components/PaymentUploadSummary';

const Schema = Yup.object().shape({
  fundingAccount: Yup.string().required('Funding Account is required'),
});

const initialValues = {
  fundingAccount: '',
};

const StampDutyBulkUpload = () => {
  const [stampDutyFile, setStampDutyFile] = useState<string>();
  const [successModal, setSuccessModal] = useState(false);
  const [fundingAcctModal, setFundingAcctModal] = useState(false);
  const [showPensionPayrollTable, setShowPensionPayrollTable] =
    useState<boolean>(false);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [accountToMakePaymentFrom, setAccountToMakePaymentFrom] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [totalPayableSum, setTotalPayableSum] = useState<number>(0);

  const navigate = useNavigate();

  const {
    data: bankData,
    mutate: mutateBankData,
    isLoading: isLoadingBankData,
  } = useGetUserBankDetails();

  const {
    data: batchId,
    mutate: mutateBatchId,
    isLoading: isLoadingBatchId,
  } = useGetBatchId();

  const { data, error, mutate, isLoading } = useCreateSinglePaymentRequest();

  useEffect(() => {
    mutateBatchId();
    mutateBankData();
  }, []);

  const handleSelectAccountChange = (event) => {
    setAccountToMakePaymentFrom(event.target.value);
  };

  let totalAmount:number = 0

  function extractData($event: any) {
    const file = $event.target.files[0];
    setStampDutyFile(file.name);
    if (file.type === 'text/csv') {
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (event: any) => {
        const csvString = event.target.result;

        let rows = csvString.split('\n');

        rows = rows.filter((line) => line.trim() !== '');

        const headers = rows[0].trim().split(',');
        const data: any[] = [];

        for (let i = 1; i < rows.length; i++) {
          let values = rows[i].trim();
          values = values.split(',');

          const obj = {};
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j].trim()] = values[j].trim();
            if (j === 9) {
              let amount = values[j].replace('₦', '');
              amount = Number(amount);
              //console.log("amount: ", totalAmount + amount);
              totalAmount = totalAmount + amount;
              setTotalPayableSum(totalAmount);
            }
          }
          data.push(obj);

          setDataSource(data);

          //console.log("dataSource: ", data);
        }
      };
    } else {
      ErrorToast('Invalid File type Select a CSV File');
    }
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    //console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: 'Employee ID',
      dataIndex: 'employeeId',
      key: 'employeeId',
    },
    {
      title: 'Employee TIN',
      dataIndex: 'employeeTin',
      key: 'employeeTin',
    },
    {
      title: 'Employee First Name',
      dataIndex: 'employeeFirstName',
      key: 'employeeFirstName',
    },
    {
      title: 'Employee Last Name',
      dataIndex: 'employeeLastName',
      key: 'employeeLastName',
    },
    {
      title: 'Employee BVN',
      dataIndex: 'employeeBvn',
      key: 'employeeBvn',
    },
    {
      title: 'Employee Phone Number',
      dataIndex: 'tpPhoneNumber',
      key: 'tpPhoneNumber',
    },
    {
      title: 'Employee Email',
      dataIndex: 'employeeEmail',
      key: 'employeeEmail',
    },
    {
      title: 'Gross Income',
      dataIndex: 'grossIncome',
      key: 'grossIncome',
      render: (_, data) => (
        <span>{formatMoneyLocal(data?.grossIncome ?? 0)}</span>
      ),
    },
    {
      title: 'Chargeable Income',
      dataIndex: 'chargeableIncome',
      key: 'chargeableIncome',
      render: (_, data) => (
        <span>{formatMoneyLocal(data?.chargeableIncome ?? 0)}</span>
      ),
    },
    {
      title: 'Tax Payable',
      dataIndex: 'taxPayable',
      key: 'taxPayable',
      render: (_, data) => (
        <span>{formatMoneyLocal(data?.taxPayable ?? 0)}</span>
      ),
    },
    // {
    //   title: 'Pay period',
    //   dataIndex: 'payPeriod',
    //   key: 'payPeriod',
    // },
    {
      title: 'Tax State',
      dataIndex: 'taxState',
      key: 'taxState',
    },
  ];

  function submitPayment() {
    console.log(dataSource);

    setConfirmationModal(false);

    const accountData = accountToMakePaymentFrom.split('-');

    const updatedArray = dataSource.map((obj) => {
      console.log(obj);

      const updatedObj = {
     sourceAccount: accountData[0],
                beneficiaryFirstName: obj.employeeFirstName,
                beneficiaryLastName: obj.employeeLastName,
                amount: obj.taxPayable,
                beneficiaryTin: obj.employeeTin,
                contractAmount: obj.grossIncome,
                sourceBankAccountCode: accountData[2],
          sourceName: accountData[1],
          email: obj.employeeEmail,
          bvn: obj.employeeBvn,
                 phoneNumber: obj.tpPhoneNumber,
                from: obj.payPeriod,
                to: obj.payPeriod,
                taxPayable: obj.taxPayable,
                paymentType: {
                  code: 'paye_payment',
                  description: 'Paye',
                },
                destAccountName: `${obj.employeeFirstName} ${obj.employeeLastName} `,
      };

      console.log(updatedObj);

      return updatedObj;
    });

    mutate(
      {
        data: {
          batchId: batchId,
          accountType: {
            code: accountData[2],
            value: accountData[3],
          },
          narration: 'Paye',
          expenseType: 'Paye',
          paymentType: {
            code: 'paye_payment',
            description: 'Paye',
          },
          paymentInstructions: updatedArray,
        },
      },
      {
        onSuccess: (res: any) => {
          setSuccessModal(true);
        },
      }
    );
  }

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: async (values) => {},
  });

  let fundingAccount = [
    {
      id: '',
      description: 'Account number',
    },
    {
      id: '1',
      description: 'First Bank of Nigeria PLC (099***5545)',
    },
  ];

  return (
    <>
      {isLoading ||
      isLoadingBatchId ||
      isLoadingBankData ||
      isLoadingBatchId ? (
        <div className="d-flex justify-content-center align-items-center my-10">
          <MetroSpinner color="#1f8505" />
        </div>
      ) : (
        <div className={"vatPayment"}>
          <div className={"vatPaymentBreadcrumb"}>
            <div>Payments</div>
            <svg
              width="10"
              height="13"
              viewBox="0 0 10 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
                fill="#1F8505"
              />
            </svg>
            <div>Tax Payments</div>

            <svg
              width="10"
              height="13"
              viewBox="0 0 10 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
                fill="#1F8505"
              />
            </svg>
            <div>Stamp Duty</div>

            <svg
              width="10"
              height="13"
              viewBox="0 0 10 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
                fill="#1F8505"
              />
            </svg>

            <div>Multiple Payment</div>
          </div>

          {!showPensionPayrollTable ? (
            <div className={"vatBulkUploadDiv"}>
              <div className={"vatBulkUpload"}>
                <div onClick={() => navigate(-1)}>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_7037_76293)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18 11.8125H9.63312L13.4763 7.96937L12.5 7L7 12.5L12.5 18L13.4694 17.0306L9.63312 13.1875H18V11.8125Z"
                        fill="#1F8505"
                      />
                    </g>
                    <rect
                      x="0.75"
                      y="1.25"
                      width="22.5"
                      height="22.5"
                      rx="11.25"
                      stroke="#1F8505"
                      stroke-width="1.5"
                    />
                    <defs>
                      <clipPath id="clip0_7037_76293">
                        <rect
                          y="0.5"
                          width="24"
                          height="24"
                          rx="12"
                          fill="white"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div className={"vatUploadText"}>Stamp Duty Upload from Excel</div>
              </div>

              <div style={{ textAlign: "center" }}>
                <a className={"downloadTemplate"} href={StampDuty}>
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.5 7.5H8V11H8.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
                        stroke="#48B460"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z"
                        fill="#48B460"
                      />
                    </svg>
                  </span>
                  Download a Paye Upload File
                </a>
              </div>

              <div className={"vatFileUploadDiv"}>
                <div>File</div>

                <label>
                  <div>Browse...</div>
                  <div>
                    {stampDutyFile ? stampDutyFile : "No file selected"}
                  </div>
                  <input
                    hidden
                    id="input"
                    type="file"
                    accept="text/csv"
                    onChange={extractData}
                  />
                </label>

                <div>Accepted file types are .csv, .xls, .xlxs</div>
              </div>

              <div className={"vatUploadButton"}>
                <button
                  disabled={isEmpty(dataSource)}
                  onClick={() => setShowPensionPayrollTable(true)}
                >
                  Upload
                </button>
              </div>
            </div>
          ) : (
            <>
              <PaymentUploadSummary
                paymentType="Paye"
                batchId={batchId}
                dataSource={dataSource}
                totalPayableSum={totalPayableSum}
                processingFee={100 * Number(dataSource.length)}
              />
              <div className={"pensionPaymentTable"}>
                <div className={"pensionPaymentTableRow1"}>
                  <div>
                    <button
                      onClick={() =>
                        navigate("/admin/payment/tax-payments/stamp-duty")
                      }
                    >
                      Go back
                    </button>
                  </div>

                  <div>
                    <button onClick={() => setFundingAcctModal(true)}>
                      Submit
                    </button>
                  </div>
                </div>

                <div className={"pensionPaymentTableRow2"}>
                  <Table
                    rowSelection={rowSelection}
                    dataSource={[...dataSource]}
                    columns={columns}
                    scroll={{ x: "2000px" }}
                  />
                </div>
              </div>
            </>
          )}

          <Modal
            centered
            style={{ width: "500px", maxWidth: "100%" }}
            open={fundingAcctModal}
            onOk={() => setFundingAcctModal(false)}
            onCancel={() => setFundingAcctModal(false)}
            footer={null}
            closable={false}
          >
            <div className={"tpSuccessModal"}>
              <div className={"tpSuccessModalRow1"}>
                <div
                  onClick={() => {
                    setShowPensionPayrollTable(true);
                    setFundingAcctModal(false);
                  }}
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_7037_76293)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18 11.8125H9.63312L13.4763 7.96937L12.5 7L7 12.5L12.5 18L13.4694 17.0306L9.63312 13.1875H18V11.8125Z"
                        fill="#1F8505"
                      />
                    </g>
                    <rect
                      x="0.75"
                      y="1.25"
                      width="22.5"
                      height="22.5"
                      rx="11.25"
                      stroke="#1F8505"
                      stroke-width="1.5"
                    />
                    <defs>
                      <clipPath id="clip0_7037_76293">
                        <rect
                          y="0.5"
                          width="24"
                          height="24"
                          rx="12"
                          fill="white"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div>Select Funding Account</div>
              </div>

              <div className={"selectFundingDiv"}>
                <div>Account number</div>

                <div>
                  <div className={`mt-1`}>
                    <div className={`form-control form-control-solid`}>
                      <select
                        className={`no-outline fs-8 text-muted`}
                        onChange={(e: any) => handleSelectAccountChange(e)}
                      >
                        <option value="">
                          Select account to make payment from
                        </option>
                        {bankData?.map((array: any, i: any) => {
                          return (
                            <option
                              value={`${array.accountNumber}-${array.accountName}-${array.accountType.code}-${array.accountType.description}`}
                              key={i}
                            >
                              {array?.accountName}- {array?.accountNumber}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div></div>
                </div>
              </div>

              <div className={"tpSuccessModalActionButton"}>
                <button
                  onClick={() => {
                    // setSuccessModal(true);

                    setConfirmationModal(true);
                    setFundingAcctModal(false);
                  }}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>

          <Modal
            centered
            style={{ width: "500px", maxWidth: "100%" }}
            open={successModal}
            onOk={() => {
              navigate("/admin/payment/tax-payments");
              setSuccessModal(false);
            }}
            onCancel={() => {
              navigate("/admin/payment/tax-payments");
              setSuccessModal(false);
            }}
            footer={null}
          >
            <div className={"ppSuccessModal"}>
              <svg
                style={{ justifySelf: "center" }}
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M33.5937 20.3125L22.1354 31.25L16.4062 25.7812M43.75 25C43.75 35.3553 35.3553 43.75 25 43.75C14.6447 43.75 6.25 35.3553 6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3553 6.25 43.75 14.6447 43.75 25Z"
                  stroke="#FBCB38"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div className={"ppSuccessModalTitle"}>Successful!</div>

              <div className={"ppSuccessModalDesc"}>
                Your transaction with Batch ID {batchId} has been sent to the
                reviewer group for action.
              </div>

              <div className={"ppSuccessModalActionButton"}>
                <button
                  onClick={() => {
                    navigate("/admin/payment/tax-payments");
                    setSuccessModal(false);
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          </Modal>

          <Modal
            centered
            style={{ width: "500px", maxWidth: "100%" }}
            open={confirmationModal}
            onOk={() => setConfirmationModal(false)}
            onCancel={() => setConfirmationModal(false)}
            footer={null}
          >
            <div className={"rvpConfirmationModal"}>
              <svg
                style={{ justifySelf: "center" }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                  fill="#61CD85"
                />
              </svg>

              {/*<div className={'rdFilterModalRow1'}>*/}
              <div className={"rvpConfirmationModalTitle"}>Confirmation</div>
              {/*</div>*/}

              <div style={{ justifySelf: "center" }}>
                Please confirm you want to proceed with this request
              </div>

              <div className={"rvpConfirmationModalActionButton"}>
                <button
                  className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1"
                  onClick={() => setConfirmationModal(false)}
                >
                  <span className="indicator-label fs-base">Cancel</span>
                </button>

                <button
                  onClick={() => submitPayment()}
                  className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                >
                  <span className="indicator-label fs-base text-White">
                    Proceed
                  </span>
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default StampDutyBulkUpload;
